import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-dialog-video',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './dialog-video.component.html',
  styleUrl: './dialog-video.component.css'
})
export class DialogVideoComponent {

  videoUrl: string;

  constructor(
    private dialogRef: MatDialogRef<DialogVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { videoUrl: string }
  ) {
    this.videoUrl = data.videoUrl;
  }

  close(): void {
    this.dialogRef.close();
  }
}
